import { render, staticRenderFns } from "./DocsNavigation.vue?vue&type=template&id=120b767a&"
import script from "./DocsNavigation.vue?vue&type=script&lang=js&"
export * from "./DocsNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports